// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-unsafe-return, react-hooks/exhaustive-deps, @typescript-eslint/no-unsafe-argument, @typescript-eslint/strict-boolean-expressions */

import {
  Autocomplete,
  AutocompleteChangeReason,
  autocompleteClasses,
  AutocompleteInputChangeReason,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  Theme,
  alpha,
} from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import {
  dayjs,
  formatAsPercentage,
  getDateFormatted,
  getAvg,
  isBloomberg,
  nullsToEndComparator,
  valOrNa,
  prevBusinessDayOpenMarket,
  formatAsCurrency,
  applyNumericComparison,
  isWithinPercent,
} from '../../../util';
import {
  forwardRef,
  Ref,
  SyntheticEvent,
  useCallback,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';
import { formatAsCompactNumber } from '../../../util';
import * as d3 from 'd3';
import {
  getGridNumericOperators,
  GridColDef,
  GridColumnGroup,
  GridColumnGroupHeaderParams,
  GridColumnHeaderParams,
  gridDateComparator,
  GridFilterInputValueProps,
  GridFilterItem,
  GridFilterOperator,
  gridNumberComparator,
  GridRenderCellParams,
  gridStringOrNumberComparator,
} from '@spotgamma/x-data-grid-premium';
import { useRecoilValue } from 'recoil';
import {
  COLUMN_TO_GROUP_MAPPING,
  scannerOnlyFields,
  historyOnlyFields,
  EQUITIES_TOOLTIP_MAP,
  EQUITY_FIELD_LABEL_MAPPING,
} from '../../../config';
import {
  timezoneState,
  positiveTrendColorState,
  negativeTrendColorState,
  userIsLoggedInState,
} from '../../../states';
import { EquityFieldKey } from '../../../types';
import { SGTooltip } from '../../core';
import RowWatchlistBtn from '../../stock_scanner/RowWatchlistBtn';
import StockIcon from '../../StockIcon';

export const enum EquityTableType {
  History,
  StockScreener,
}

const SYNTH_OI_KEY_LEVELS = [
  { field: EquityFieldKey.high_vol_point },
  { field: EquityFieldKey.low_vol_point },
  { field: EquityFieldKey.optionsImpact },
  { field: EquityFieldKey.callGamma },
  { field: EquityFieldKey.putGamma },
  { field: EquityFieldKey.callDelta },
  { field: EquityFieldKey.putDelta },
  { field: EquityFieldKey.nextExpGamma },
  { field: EquityFieldKey.nextExpDelta },
  { field: EquityFieldKey.topGammaExp },
  { field: EquityFieldKey.topDeltaExp },
  { field: EquityFieldKey.callVolume },
  { field: EquityFieldKey.putVolume },
  { field: EquityFieldKey.neCallVolume },
  { field: EquityFieldKey.nePutVolume },
];

const LEGACY_KEY_LEVELS = [
  { field: EquityFieldKey.keyGammaStr },
  { field: EquityFieldKey.keyDeltaStr },
  { field: EquityFieldKey.hedgeWall },
  { field: EquityFieldKey.callWall },
  { field: EquityFieldKey.putWall },
  { field: EquityFieldKey.optionsImpact },
  { field: EquityFieldKey.callGamma },
  { field: EquityFieldKey.putGamma },
  { field: EquityFieldKey.callDelta },
  { field: EquityFieldKey.putDelta },
  { field: EquityFieldKey.nextExpGamma },
  { field: EquityFieldKey.nextExpDelta },
  { field: EquityFieldKey.topGammaExp },
  { field: EquityFieldKey.topDeltaExp },
  { field: EquityFieldKey.callVolume },
  { field: EquityFieldKey.putVolume },
  { field: EquityFieldKey.neCallVolume },
  { field: EquityFieldKey.nePutVolume },
];

const ALL_EQUITY_FIELDS_ARRAY = Object.values(EquityFieldKey);

const ALL_EQUITY_NUMERIC_FIELDS_ARRAY = [
  EquityFieldKey.price,
  EquityFieldKey.prevClose,
  EquityFieldKey.stock_volume,
  EquityFieldKey.wkHigh52,
  EquityFieldKey.wkLow52,
  EquityFieldKey.callGamma,
  EquityFieldKey.putGamma,
  EquityFieldKey.callDelta,
  EquityFieldKey.putDelta,
  EquityFieldKey.nextExpGamma,
  EquityFieldKey.nextExpDelta,
  EquityFieldKey.callVolume,
  EquityFieldKey.putVolume,
  EquityFieldKey.neCallVolume,
  EquityFieldKey.nePutVolume,
  EquityFieldKey.skew,
  EquityFieldKey.skewRank,
  EquityFieldKey.high_vol_point,
  EquityFieldKey.low_vol_point,
  EquityFieldKey.optionsImpact,
  EquityFieldKey.putCallVolRatio,
  EquityFieldKey.gammaRatio,
  EquityFieldKey.deltaRatio,
  EquityFieldKey.putCallRatio,
  EquityFieldKey.keyGammaStr,
  EquityFieldKey.keyDeltaStr,
  EquityFieldKey.hedgeWall,
  EquityFieldKey.callWall,
  EquityFieldKey.putWall,
  EquityFieldKey.neSkew,
  EquityFieldKey.rv30,
  EquityFieldKey.iv30,
  EquityFieldKey.ivRank,
  EquityFieldKey.dpi,
  EquityFieldKey.dpiVol,
  EquityFieldKey.dpi5day,
  EquityFieldKey.dpi5dayVol,
];

const SYNTH_OI_ONLY_COLUMNS = [
  EquityFieldKey.high_vol_point,
  EquityFieldKey.low_vol_point,
];

const LEGACY_ONLY_COLUMNS = [
  EquityFieldKey.keyGammaStr,
  EquityFieldKey.keyDeltaStr,
  EquityFieldKey.hedgeWall,
  EquityFieldKey.callWall,
  EquityFieldKey.putWall,
  EquityFieldKey.putCallVolRatio,
  EquityFieldKey.dpi,
  EquityFieldKey.dpiVol,
  EquityFieldKey.dpi5day,
  EquityFieldKey.dpi5dayVol,
];

const PERCENTAGE_COLUMN_KEYS = [
  EquityFieldKey.nextExpGamma,
  EquityFieldKey.nextExpDelta,
  EquityFieldKey.iv30,
  EquityFieldKey.ivRank,
  EquityFieldKey.dpi,
  EquityFieldKey.dpiVol,
  EquityFieldKey.dpi5day,
  EquityFieldKey.dpi5dayVol,
  EquityFieldKey.skew,
  EquityFieldKey.skewRank,
  EquityFieldKey.neSkew,
  EquityFieldKey.rv30,
];

const COLUMN_ID_OFFSET = 100_000_000; // Start at 100,000,000

const getColumnToIndexMap = (): Map<EquityFieldKey, number> => {
  const columnIds = new Map<EquityFieldKey, number>();

  ALL_EQUITY_FIELDS_ARRAY.forEach((field, index) => {
    columnIds.set(field, -(index + 1) / COLUMN_ID_OFFSET);
  });

  return columnIds;
};

const getIndexToColumnMap = (): Map<number, EquityFieldKey> => {
  const columnIds = new Map<number, EquityFieldKey>();

  ALL_EQUITY_FIELDS_ARRAY.forEach((field, index) => {
    columnIds.set(-(index + 1) / COLUMN_ID_OFFSET, field);
  });

  return columnIds;
};

interface FilterOption {
  type: 'column' | 'custom';
  label: string;
  value: number | string;
  description?: string;
}

export const useEquityGridColumns = (
  theme: Theme,
  dpiRange: number[] | undefined,
  tableType: EquityTableType,
  isSynthOI: boolean,
  blurredRowIds?: string[],
) => {
  const isMobile = useIsMobile();
  const currentTimezone = useRecoilValue(timezoneState);
  const isLoggedIn = useRecoilValue(userIsLoggedInState);

  const serverPositiveTrendColor: string = useRecoilValue(
    positiveTrendColorState,
  );
  const serverNegativeTrendColor: string = useRecoilValue(
    negativeTrendColorState,
  );

  const dpiColorScale = useMemo(
    () => dpiRange && d3.scaleSequential(d3.interpolateRdYlGn).domain(dpiRange),
    [dpiRange],
  );

  const history = tableType === EquityTableType.History;

  const defaultHeaderTitleStyles = {
    fontSize: isMobile ? 11 : 13,
    color: theme.palette.sgGreen,
    textTransform: 'capitalize',
    textAlign: 'right',
    whiteSpace: 'normal',
    lineHeight: 'normal',
  };

  const getColHeaderStyles = useCallback(
    (params: GridColumnHeaderParams) => ({
      ...defaultHeaderTitleStyles,
      color: COLUMN_TO_GROUP_MAPPING[
        params.field as keyof typeof COLUMN_TO_GROUP_MAPPING
      ]
        ? alpha(
            theme.palette.equityHubColumns[
              COLUMN_TO_GROUP_MAPPING[
                params.field as keyof typeof COLUMN_TO_GROUP_MAPPING
              ]
            ],
            0.85,
          )
        : 'inherit',
    }),
    [defaultHeaderTitleStyles, theme.palette.equityHubColumns],
  );

  const columnIdentifiers = useMemo(() => getColumnToIndexMap(), []);
  const indexToColumn = useMemo(() => getIndexToColumnMap(), []);

  const getHistoryTextColor = useCallback(
    (params: GridRenderCellParams, field: EquityFieldKey) => {
      if (!history) {
        return 'inherit';
      }

      // Assuming id is in the YYYY-MM-DD format since historical table uses formatted date ids
      const currentDayKey = params.id;
      const previousDayKey = getDateFormatted(
        prevBusinessDayOpenMarket(dayjs(currentDayKey)),
      );

      // Accessing the previous day's row
      const previousDayRow = params.api.getRow(previousDayKey);

      if (!previousDayRow || params.value === previousDayRow?.[field]) {
        return 'inherit';
      }

      return params.value < previousDayRow?.[field]
        ? serverNegativeTrendColor
        : serverPositiveTrendColor;
    },
    [history, serverNegativeTrendColor, serverPositiveTrendColor],
  );

  const getBlurredStyles = (params: GridRenderCellParams) =>
    blurredRowIds?.includes(params.id as string) ? { filter: 'blur(3px)' } : {};

  const getColoredCell = useCallback(
    (
      params: GridRenderCellParams,
      isCurrency = false,
      minFractionDigits?: number,
    ) => (
      <Typography
        sx={{
          color: getHistoryTextColor(params, params.field as EquityFieldKey),
          ...getBlurredStyles(params),
        }}
      >
        {params.value != null && !isNaN(params.value)
          ? isCurrency
            ? valOrNa(formatAsCurrency(params.value, false, minFractionDigits))
            : valOrNa(
                formatAsCompactNumber(params.value, {
                  maximumFractionDigits: 2,
                }),
              )
          : valOrNa(params.value)}
      </Typography>
    ),
    [getHistoryTextColor, getBlurredStyles],
  );

  // Shared column-or-number picker — used by both the simple comparison
  // operators and WithinPercentFilterInput's target field.
  const ColumnOrNumberAutocomplete = forwardRef<
    { focus: () => void },
    {
      value: number | string | undefined;
      onChange: (value: number | string) => void;
      width?: string | number;
      label?: string;
    }
  >(({ value, onChange, width = '200px', label }, ref) => {
    const [inputValue, setInputValue] = useState(
      indexToColumn.get(value as number)
        ? EQUITY_FIELD_LABEL_MAPPING[indexToColumn.get(value as number)!]
        : (value ?? ''),
    );
    const inputRef: Ref<HTMLInputElement> = useRef(null);

    useImperativeHandle(ref, () => ({
      focus: () => {
        inputRef.current?.focus();
      },
    }));

    // Create options from available columns
    const columnOptions: FilterOption[] =
      ALL_EQUITY_NUMERIC_FIELDS_ARRAY.filter((field) =>
        isSynthOI
          ? !LEGACY_ONLY_COLUMNS.includes(field)
          : !SYNTH_OI_ONLY_COLUMNS.includes(field),
      ).map((field) => ({
        type: 'column' as const,
        label: EQUITY_FIELD_LABEL_MAPPING[field],
        value: columnIdentifiers.get(field)!,
        description: `Compare with ${EQUITY_FIELD_LABEL_MAPPING[field]} column`,
      }));

    const currentValue = value ?? '';

    // Determine current selection - return null for custom values since they're not in options
    const getCurrentOption = (): FilterOption | null => {
      if (currentValue === '' || currentValue == null) {
        return null;
      }

      // Check if it's a column index
      if (
        typeof currentValue === 'number' &&
        currentValue >= 0 &&
        currentValue < ALL_EQUITY_FIELDS_ARRAY.length
      ) {
        const field = ALL_EQUITY_FIELDS_ARRAY[currentValue];
        if (ALL_EQUITY_NUMERIC_FIELDS_ARRAY.includes(field)) {
          return (
            columnOptions.find((opt) => opt.value === currentValue) || null
          );
        }
      }

      // For custom numeric values, return null (freeSolo will handle display)
      return null;
    };

    const handleChange = (
      _event: SyntheticEvent,
      newValue: string | FilterOption | null,
      reason: AutocompleteChangeReason,
    ) => {
      if (reason === 'clear') {
        onChange('');
        setInputValue('');
        return;
      }

      if (
        newValue &&
        typeof newValue === 'object' &&
        reason === 'selectOption'
      ) {
        onChange(newValue.value);
        setInputValue(newValue.label);
      }
    };

    const handleInputChange = (
      _event: SyntheticEvent,
      newInputValue: string,
      _reason: AutocompleteInputChangeReason,
    ) => {
      setInputValue(newInputValue);
    };

    // Apply value on blur or Enter so user can finish typing without input deselecting
    const handleApply = () => {
      const numericValue = parseFloat(inputValue);
      if (!isNaN(numericValue)) {
        onChange(numericValue);
      } else if (inputValue === '') {
        onChange('');
      }
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleApply();
      }
    };

    return (
      <Autocomplete
        ref={inputRef}
        value={getCurrentOption()}
        onChange={handleChange}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        options={columnOptions}
        getOptionLabel={(option: FilterOption | string) =>
          typeof option === 'string' ? option : option.label
        }
        isOptionEqualToValue={(
          option: FilterOption | string,
          value: FilterOption | string,
        ) => {
          if (typeof option === 'string' && typeof value === 'string') {
            return option === value;
          }
          if (typeof option === 'object' && typeof value === 'object') {
            return option.value === value.value;
          }
          return false;
        }}
        freeSolo
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Enter value or select column"
            variant="outlined"
            InputLabelProps={
              label
                ? { ...params.InputLabelProps, shrink: true }
                : params.InputLabelProps
            }
            InputProps={{
              ...params.InputProps,
              onBlur: handleApply,
            }}
            onKeyDown={handleKeyDown}
            sx={{
              width,
            }}
          />
        )}
        clearOnBlur={false}
        selectOnFocus
        handleHomeEndKeys
        filterOptions={(options, { inputValue }) => {
          // Show all options when there's no input
          if (inputValue == null) {
            return options;
          }

          // Filter options based on input
          return options.filter((option) =>
            option.label
              .toLowerCase()
              .includes(String(inputValue).toLowerCase()),
          );
        }}
        componentsProps={{
          popper: {
            sx: {
              zIndex: 9_999,
              [`& .${autocompleteClasses.listbox}`]: {
                boxSizing: 'border-box',
                '& ul': {
                  padding: 0,
                  margin: 0,
                },
                backgroundColor: theme.palette.background.paper,
                boxShadow: theme.shadows[3],
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              },
            },
          },
        }}
      />
    );
  });
  ColumnOrNumberAutocomplete.displayName = 'ColumnOrNumberAutocomplete';

  const CustomColumnComparisonInput = ({
    item,
    applyValue,
    focusElementRef,
  }: GridFilterInputValueProps) => (
    <ColumnOrNumberAutocomplete
      ref={focusElementRef as Ref<{ focus: () => void }>}
      value={item.value}
      onChange={(newValue) => applyValue({ ...item, value: newValue })}
    />
  );

  const WithinPercentFilterInput = ({
    item,
    applyValue,
    focusElementRef,
  }: GridFilterInputValueProps) => {
    // Array shape, not an object — see withinPercentOperator for why.
    const [initialPercent, initialTarget] = Array.isArray(item.value)
      ? item.value
      : [];
    const [filterValue, setFilterValue] = useState<{
      percent: number | string;
      target: number | string;
    }>({
      percent: initialPercent ?? '',
      target: initialTarget ?? '',
    });
    const [percentInput, setPercentInput] = useState(
      String(filterValue.percent),
    );
    const percentInputRef: Ref<HTMLInputElement> = useRef(null);

    useImperativeHandle(focusElementRef, () => ({
      focus: () => {
        percentInputRef.current?.focus();
      },
    }));

    const commit = (next: {
      percent: number | string;
      target: number | string;
    }) => {
      setFilterValue(next);
      applyValue({ ...item, value: [next.percent, next.target] });
    };

    const handlePercentApply = () => {
      const parsed = parseFloat(percentInput);
      commit({ ...filterValue, percent: isNaN(parsed) ? '' : parsed });
    };

    const handlePercentKeyDown = (event: React.KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handlePercentApply();
      }
    };

    return (
      <Stack sx={{ gap: 3, width: '100%', pt: 0, pb: 0.5 }}>
        <TextField
          inputRef={percentInputRef}
          type="number"
          size="small"
          variant="outlined"
          label="Percent"
          InputLabelProps={{ shrink: true }}
          value={percentInput}
          onChange={(event) => setPercentInput(event.target.value)}
          onBlur={handlePercentApply}
          onKeyDown={handlePercentKeyDown}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-input': {
              MozAppearance: 'textfield',
            },
            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
              {
                WebkitAppearance: 'none',
                margin: 0,
              },
          }}
        />
        <ColumnOrNumberAutocomplete
          value={filterValue.target}
          onChange={(newTarget) =>
            commit({ ...filterValue, target: newTarget })
          }
          width="100%"
          label="Of (value or column)"
        />
      </Stack>
    );
  };

  const wrapOperator = (operator: GridFilterOperator): GridFilterOperator => {
    return {
      ...operator,
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (
          filterItem.field == null ||
          filterItem.operator == null ||
          filterItem.value === '' ||
          filterItem.value == null
        ) {
          return null;
        }

        const compareColumnField = indexToColumn.get(
          filterItem.value as number,
        );

        return (value, row, column) => {
          if (value == null) {
            return false;
          }

          const isPercentage = PERCENTAGE_COLUMN_KEYS.includes(
            column.field as EquityFieldKey,
          );

          // Handle comparison with user-entered numeric value
          if (compareColumnField == null) {
            if (filterItem.value == null || isNaN(Number(filterItem.value))) {
              return false;
            }
            return applyNumericComparison(
              Number(isPercentage ? value * 100 : value),
              Number(filterItem.value), // we assume the user typed value is in the same format as the column, hence conversion not needed (i.e. percentage or not)
              operator.value,
            );
          }

          // Handle comparison with another column
          return applyNumericComparison(
            Number(value),
            Number(row[compareColumnField]),
            operator.value,
          );
        };
      },
      InputComponent: CustomColumnComparisonInput,
    };
  };

  // Value must stay a [percent, target] array, not a {percent, target} object —
  // numeric columns' default valueParser runs Number() on it before we ever see
  // it, which is a no-op per array element but NaN on a plain object.
  const withinPercentOperator: GridFilterOperator = {
    value: 'withinPercent',
    label: 'is within %',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      const [percent, target] = Array.isArray(filterItem.value)
        ? filterItem.value
        : [];

      if (
        percent === '' ||
        percent == null ||
        isNaN(Number(percent)) ||
        target === '' ||
        target == null ||
        isNaN(Number(target))
      ) {
        return null;
      }

      const percentNum = Number(percent);
      const compareColumnField = indexToColumn.get(target as number);

      return (value, row, column) => {
        if (value == null) {
          return false;
        }

        const isPercentage = PERCENTAGE_COLUMN_KEYS.includes(
          column.field as EquityFieldKey,
        );

        // Handle comparison with another column
        if (compareColumnField != null) {
          return isWithinPercent(
            Number(value),
            Number(row[compareColumnField]),
            percentNum,
          );
        }

        // Handle comparison with user-entered numeric value
        return isWithinPercent(
          isPercentage ? value * 100 : value,
          Number(target),
          percentNum,
        );
      };
    },
    getValueAsString: (value: unknown) => {
      const [percent, target] = Array.isArray(value) ? value : [];
      if (percent === '' || percent == null) {
        return '';
      }

      const compareColumnField = indexToColumn.get(target as number);
      const targetLabel = compareColumnField
        ? EQUITY_FIELD_LABEL_MAPPING[compareColumnField]
        : target;

      return targetLabel != null && targetLabel !== ''
        ? `${percent}% of ${targetLabel}`
        : `${percent}%`;
    },
    InputComponent: WithinPercentFilterInput,
  };

  const customNumericOperators = [
    ...getGridNumericOperators().map((operator) => {
      if (
        operator.value === '=' ||
        operator.value === '!=' ||
        operator.value === '>' ||
        operator.value === '<' ||
        operator.value === '>=' ||
        operator.value === '<='
      ) {
        return wrapOperator(operator);
      }
      return operator;
    }),
    withinPercentOperator,
  ];

  const columnGroups: GridColumnGroup[] = history
    ? []
    : [
        {
          groupId: 'general_ticker_info',
          headerName: 'Ticker Information',
          description: '',
          headerClassName: 'custom-group-header',
          freeReordering: true,
          children: [
            { field: EquityFieldKey.price },
            { field: EquityFieldKey.prevClose },
            { field: EquityFieldKey.stock_volume },
            { field: EquityFieldKey.wkHigh52 },
            { field: EquityFieldKey.wkLow52 },
            { field: EquityFieldKey.earningsDate },
          ],
          renderHeaderGroup: (_params: GridColumnGroupHeaderParams) => (
            <Typography
              sx={{
                ...defaultHeaderTitleStyles,
                fontWeight: 'bold',
                color: theme.palette.equityHubColumns.STATISTICS,
              }}
            >
              Ticker Information
            </Typography>
          ),
        },
        {
          groupId: 'sg_key_daily_levels',
          headerName: 'SpotGamma Key Daily Levels',
          description: '',
          headerClassName: 'custom-group-header',
          freeReordering: true,
          children: isSynthOI ? SYNTH_OI_KEY_LEVELS : LEGACY_KEY_LEVELS,
          renderHeaderGroup: (_params: GridColumnGroupHeaderParams) => (
            <Typography
              sx={{
                ...defaultHeaderTitleStyles,
                fontWeight: 'bold',
                color: theme.palette.equityHubColumns.SG_KEY_DAILY_LEVELS,
              }}
            >
              SpotGamma Key Daily Levels
            </Typography>
          ),
        },
        {
          groupId: 'directional_indicators',
          headerName: 'Directional Indicators',
          description: '',
          headerClassName: 'custom-group-header',
          freeReordering: true,
          children: [
            { field: EquityFieldKey.putCallVolRatio },
            { field: EquityFieldKey.gammaRatio },
            { field: EquityFieldKey.deltaRatio },
            { field: EquityFieldKey.putCallRatio },
          ],
          renderHeaderGroup: (_params: GridColumnGroupHeaderParams) => (
            <Typography
              sx={{
                ...defaultHeaderTitleStyles,
                fontWeight: 'bold',
                color: theme.palette.equityHubColumns.DIRECTIONAL_INDICATORS,
              }}
            >
              Directional Indicators
            </Typography>
          ),
        },
        {
          groupId: 'vol_insights',
          headerName: 'Volatility Insights',
          description: '',
          headerClassName: 'custom-group-header',
          freeReordering: true,
          children: [
            { field: EquityFieldKey.neSkew },
            { field: EquityFieldKey.skew },
            { field: EquityFieldKey.rv30 },
            { field: EquityFieldKey.iv30 },
            { field: EquityFieldKey.ivRank },
            { field: EquityFieldKey.garchRank },
            { field: EquityFieldKey.skewRank },
            { field: EquityFieldKey.optionsImpliedMove },
          ],
          renderHeaderGroup: (_params: GridColumnGroupHeaderParams) => (
            <Typography
              sx={{
                ...defaultHeaderTitleStyles,
                fontWeight: 'bold',
                color: theme.palette.equityHubColumns.VOLATILITY_INSIGHTS,
              }}
            >
              Volatility Insights
            </Typography>
          ),
        },
        isSynthOI
          ? null
          : {
              groupId: 'dp_indicators',
              headerName: 'Dark Pool Indicators',
              description: '',
              headerClassName: 'custom-group-header',
              freeReordering: true,
              children: [
                { field: EquityFieldKey.dpi },
                { field: EquityFieldKey.dpiVol },
                { field: EquityFieldKey.dpi5day },
                { field: EquityFieldKey.dpi5dayVol },
              ],
              renderHeaderGroup: (_params: GridColumnGroupHeaderParams) => (
                <Typography
                  sx={{
                    ...defaultHeaderTitleStyles,
                    fontWeight: 'bold',
                    color: theme.palette.equityHubColumns.DARK_POOL_INDICATORS,
                  }}
                >
                  Dark Pool Indicators
                </Typography>
              ),
            },
      ].filter((g) => g != null);

  const baseColumns = useMemo(() => {
    return [
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.quoteDate],
        field: EquityFieldKey.quoteDate,
        headerClassName: 'grid-header-cell',
        minWidth: 110,
        type: 'date',
        hideable: false,
        getSortComparator: nullsToEndComparator(gridDateComparator),
        valueGetter: (value: string) => {
          return value && dayjs(value).utc().toDate();
        },
        renderCell: (params: GridRenderCellParams) => {
          const date = dayjs(params.value);
          return (
            <Typography
              sx={{
                whiteSpace: 'normal',
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(date != null && getDateFormatted(date))}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <Typography
            sx={{
              ...getColHeaderStyles(params),
            }}
          >
            {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.quoteDate]}
          </Typography>
        ),
      },
      ...(!isBloomberg() && isLoggedIn
        ? [
            {
              headerName: '',
              type: 'boolean',
              field: 'isWatchlisted',
              headerClassName: 'grid-header-cell',
              width: 45,
              hideable: false,
              filterable: false,
              disableColumnMenu: true,
              valueFormatter: (value: boolean) => `${valOrNa(value)}`,
              renderCell: RowWatchlistBtn,
            },
          ]
        : []),
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.sym],
        field: EquityFieldKey.sym,
        headerClassName: 'grid-header-cell',
        minWidth: 110,
        hideable: false,
        getSortComparator: nullsToEndComparator(gridStringOrNumberComparator),
        valueFormatter: (value: string) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Stack justifyContent="center">
              <Stack
                direction="row"
                gap={2}
                alignItems="center"
                sx={{
                  ...getBlurredStyles(params),
                }}
              >
                <StockIcon
                  symbol={params.value}
                  sx={{ width: 22, height: 22 }}
                />
                <Typography>{valOrNa(params.value)}</Typography>
              </Stack>
            </Stack>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.sym)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.sym]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.price],
        field: EquityFieldKey.price,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          if (isNaN(params.value)) {
            return null;
          }

          return (
            <Typography
              color={
                params.value > params.row.upx
                  ? theme.palette.success.main
                  : 'red'
              }
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value?.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                }),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.price)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              Current Price
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.prevClose],
        field: EquityFieldKey.prevClose,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value?.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                }),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.prevClose)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              Previous Close
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.stock_volume],
        field: EquityFieldKey.stock_volume,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value?.toLocaleString())}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.stock_volume)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.stock_volume]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.wkHigh52],
        field: EquityFieldKey.wkHigh52,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value != null && `$${params.value.toFixed(2)}`)}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.wkHigh52)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.wkHigh52]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.wkLow52],
        field: EquityFieldKey.wkLow52,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value != null && `$${params.value.toFixed(2)}`)}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.wkLow52)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.wkLow52]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.earningsDate],
        field: EquityFieldKey.earningsDate,
        type: 'date',
        headerClassName: 'grid-header-cell',
        getSortComparator: nullsToEndComparator(gridDateComparator),
        minWidth: 135,
        valueGetter: (value: string) => {
          return value && dayjs.utc(value).toDate();
        },
        valueFormatter: (value: Date) =>
          valOrNa(
            value != null &&
              `${dayjs(value.valueOf())
                .tz(currentTimezone)
                .format('MM-DD h:mm A')}`,
          ),
        renderCell: (params: GridRenderCellParams) => {
          const date = params.value;
          return (
            <Typography
              sx={{
                whiteSpace: 'normal',
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                date != null &&
                  `${dayjs(date.valueOf())
                    .tz(currentTimezone)
                    .format('MM-DD h:mm A')}`,
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.earningsDate)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.earningsDate]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callGamma],
        field: EquityFieldKey.callGamma,
        headerClassName: 'grid-header-cell',
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        minWidth: 132,
        renderCell: (params: GridRenderCellParams) => (
          <Typography
            sx={{
              ...getBlurredStyles(params),
            }}
          >
            {valOrNa(
              params.value != null && formatAsCompactNumber(params.value),
            )}
          </Typography>
        ),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.callGamma)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callGamma]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: 'Put Gamma',
        field: EquityFieldKey.putGamma,
        headerClassName: 'grid-header-cell',
        minWidth: 132,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsCompactNumber(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.putGamma)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              Put Gamma
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callDelta],
        field: EquityFieldKey.callDelta,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsCompactNumber(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.callDelta)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callDelta]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putDelta],
        field: EquityFieldKey.putDelta,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsCompactNumber(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.putDelta)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putDelta]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.nextExpGamma],
        field: EquityFieldKey.nextExpGamma,
        headerClassName: 'grid-header-cell',
        minWidth: 145,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && `${(params.value * 100).toFixed(2)}%`,
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.nextExpGamma)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.nextExpGamma]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.nextExpDelta],
        field: EquityFieldKey.nextExpDelta,
        headerClassName: 'grid-header-cell',
        minWidth: 135,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && `${(params.value * 100).toFixed(2)}%`,
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.nextExpDelta)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.nextExpDelta]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.topGammaExp],
        field: EquityFieldKey.topGammaExp,
        type: 'date',
        headerClassName: 'grid-header-cell',
        getSortComparator: nullsToEndComparator(gridDateComparator),
        valueFormatter: (value: Date) =>
          `${valOrNa(value != null && getDateFormatted(value))}`,
        minWidth: 135,
        valueGetter: (value: string) => {
          return value && dayjs.utc(value).toDate();
        },
        renderCell: (params: GridRenderCellParams) => {
          const date = params.value;
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(date != null && getDateFormatted(date))}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.topGammaExp)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.topGammaExp]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.topDeltaExp],
        field: EquityFieldKey.topDeltaExp,
        type: 'date',
        headerClassName: 'grid-header-cell',
        getSortComparator: nullsToEndComparator(gridDateComparator),
        valueFormatter: (value: Date) =>
          `${valOrNa(value != null && getDateFormatted(value))}`,
        minWidth: 135,
        valueGetter: (value: string) => {
          return value && dayjs.utc(value).toDate();
        },
        renderCell: (params: GridRenderCellParams) => {
          const date = params.value;
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(date != null && getDateFormatted(date))}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.topDeltaExp)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.topDeltaExp]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callVolume],
        field: EquityFieldKey.callVolume,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => (
          <Typography
            sx={{
              ...getBlurredStyles(params),
            }}
          >
            {valOrNa(
              params.value != null && formatAsCompactNumber(params.value),
            )}
          </Typography>
        ),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.callVolume)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callVolume]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putVolume],
        field: EquityFieldKey.putVolume,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => (
          <Typography
            sx={{
              ...getBlurredStyles(params),
            }}
          >
            {valOrNa(
              params.value != null && formatAsCompactNumber(params.value),
            )}
          </Typography>
        ),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.putVolume)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putVolume]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.neCallVolume],
        field: EquityFieldKey.neCallVolume,
        headerClassName: 'grid-header-cell',
        minWidth: 155,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && `${(params.value * 100).toFixed(2)}%`,
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.neCallVolume)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.neCallVolume]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.nePutVolume],
        field: EquityFieldKey.nePutVolume,
        headerClassName: 'grid-header-cell',
        minWidth: 155,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && `${(params.value * 100).toFixed(2)}%`,
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.nePutVolume)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.nePutVolume]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putCallRatio],
        field: EquityFieldKey.putCallRatio,
        headerClassName: 'grid-header-cell',
        minWidth: 135,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value != null && params.value.toFixed(2))}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.putCallRatio)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putCallRatio]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.gammaRatio],
        field: EquityFieldKey.gammaRatio,
        headerClassName: 'grid-header-cell',
        minWidth: 132,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value != null && Number(params.value).toFixed(2))}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.gammaRatio)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.gammaRatio]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.deltaRatio],
        field: EquityFieldKey.deltaRatio,
        headerClassName: 'grid-header-cell',
        minWidth: 120,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value != null && Number(params.value).toFixed(2))}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.deltaRatio)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.deltaRatio]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.ivRank],
        field: EquityFieldKey.ivRank,
        headerClassName: 'grid-header-cell',
        minWidth: 115,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsPercentage(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.ivRank)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.ivRank]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.garchRank],
        field: EquityFieldKey.garchRank,
        headerClassName: 'grid-header-cell',
        minWidth: 123,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsPercentage(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.garchRank)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.garchRank]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.skewRank],
        minWidth: 123,
        headerClassName: 'grid-header-cell',
        field: EquityFieldKey.skewRank,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsPercentage(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.skewRank)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.skewRank]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.neSkew],
        field: EquityFieldKey.neSkew,
        headerClassName: 'grid-header-cell',
        minWidth: 120,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsPercentage(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.neSkew)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.neSkew]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.skew],
        field: EquityFieldKey.skew,
        headerClassName: 'grid-header-cell',
        minWidth: 118,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsPercentage(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.skew)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.skew]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.rv30],
        field: EquityFieldKey.rv30,
        headerClassName: 'grid-header-cell',
        minWidth: 115,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsPercentage(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.rv30)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.rv30]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.iv30],
        field: EquityFieldKey.iv30,
        headerClassName: 'grid-header-cell',
        minWidth: 115,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(
                params.value != null && formatAsPercentage(params.value),
              )}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.iv30)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.iv30]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName:
          EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.optionsImpliedMove],
        field: EquityFieldKey.optionsImpliedMove,
        headerClassName: 'grid-header-cell',
        minWidth: 145,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
                paddingRight: '8px',
              }}
            >
              {valOrNa(params.value != null && `$${params.value.toFixed(2)}`)}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.optionsImpliedMove)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.optionsImpliedMove]}
            </Typography>
          </SGTooltip>
        ),
      },
    ];
  }, [
    getBlurredStyles,
    getColHeaderStyles,
    gridNumberComparator,
    nullsToEndComparator,
  ]);

  const legacyColumns = useMemo(() => {
    return [
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.keyGammaStr],
        field: EquityFieldKey.keyGammaStr,
        headerClassName: 'grid-header-cell',
        minWidth: 135,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: getColoredCell,
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.keyGammaStr)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
                color: alpha(
                  theme.palette.equityHubColumns[
                    COLUMN_TO_GROUP_MAPPING[
                      params.field as keyof typeof COLUMN_TO_GROUP_MAPPING
                    ]
                  ],
                  0.75,
                ),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.keyGammaStr]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.keyDeltaStr],
        field: EquityFieldKey.keyDeltaStr,
        headerClassName: 'grid-header-cell',
        minWidth: 135,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: getColoredCell,
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.keyDeltaStr)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.keyDeltaStr]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.hedgeWall],
        field: EquityFieldKey.hedgeWall,
        headerClassName: 'grid-header-cell',
        minWidth: 125,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) =>
          getColoredCell(params, true, 2),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.hedgeWall)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.hedgeWall]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callWall],
        field: EquityFieldKey.callWall,
        headerClassName: 'grid-header-cell',
        minWidth: 112,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) =>
          getColoredCell(params, true, 2),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.callWall)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.callWall]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putWall],
        field: EquityFieldKey.putWall,
        headerClassName: 'grid-header-cell',
        minWidth: 112,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) =>
          getColoredCell(params, true, 2),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.putWall)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putWall]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putCallVolRatio],
        field: EquityFieldKey.putCallVolRatio,
        headerClassName: 'grid-header-cell',
        minWidth: 135,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value != null && params.value.toFixed(2))}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.putCallVolRatio)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.putCallVolRatio]}
            </Typography>
          </SGTooltip>
        ),
      },

      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpi],
        field: EquityFieldKey.dpi,
        headerClassName: 'grid-header-cell',
        minWidth: 108,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        valueGetter: (value: number) => value && value * 100,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Stack
              sx={{
                backgroundColor: dpiColorScale
                  ? dpiColorScale(params.value)
                  : 'transparent',
                textAlign: 'end',
                minWidth: '100%',
                height: '100%',
                justifyContent: 'center',
                ...getBlurredStyles(params),
              }}
            >
              <Typography
                color={
                  params.value != null
                    ? theme.palette.grey[900]
                    : theme.palette.text.primary
                }
              >
                {valOrNa(params.value != null && `${params.value.toFixed(2)}%`)}
              </Typography>
            </Stack>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.dpi)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpi]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpiVol],
        field: EquityFieldKey.dpiVol,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(params.value != null && `${params.value.toFixed(2)}%`)}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.dpiVol)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpiVol]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpi5day],
        field: EquityFieldKey.dpi5day,
        headerClassName: 'grid-header-cell',
        minWidth: 125,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        valueGetter: (value: string) => {
          if (!value) {
            return null;
          }

          const hist_vals = value.split(',');

          return getAvg(
            hist_vals
              .slice(0, Math.min(5, hist_vals.length))
              .map((v: string) => parseFloat(v)),
          );
        },
        renderCell: (params: GridRenderCellParams) => {
          const val = params.value;
          let bg = 'transparent';

          if (params.value != null) {
            bg = dpiColorScale ? dpiColorScale(val!) : 'transparent';
          }

          return (
            <Stack
              sx={{
                backgroundColor: bg,
                minWidth: '100%',
                height: '100%',
                justifyContent: 'center',
                ...getBlurredStyles(params),
              }}
            >
              <Typography
                sx={{
                  backgroundColor: bg,
                  textAlign: 'end',
                }}
                color={
                  val != null
                    ? theme.palette.grey[900]
                    : theme.palette.text.primary
                }
              >
                {valOrNa(val != null && `${(val * 100).toFixed(2)}%`)}
              </Typography>
            </Stack>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.dpi5day)}>
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpi5day]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpi5dayVol],
        field: EquityFieldKey.dpi5dayVol,
        headerClassName: 'grid-header-cell',
        minWidth: 130,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        valueGetter: (value: string) => {
          if (!value) {
            return null;
          }

          const hist_vals = value.split(',');

          return getAvg(
            hist_vals
              .slice(0, Math.min(5, hist_vals.length))
              .map((v: string) => parseFloat(v)),
          );
        },
        renderCell: (params: GridRenderCellParams) => {
          const val: number | null = params.value;

          return (
            <Typography
              sx={{
                ...getBlurredStyles(params),
              }}
            >
              {valOrNa(val != null && `${val.toFixed(2)}%`)}
            </Typography>
          );
        },
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.dpi5dayVol)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.dpi5dayVol]}
            </Typography>
          </SGTooltip>
        ),
      },
      // Only show options impact if we're not in history mode since historical data is not available at the moment
      ...(history
        ? []
        : [
            {
              headerName:
                EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.optionsImpact],
              field: EquityFieldKey.optionsImpact,
              headerClassName: 'grid-header-cell',
              minWidth: 130,
              type: 'number',
              filterOperators: customNumericOperators,
              getSortComparator: nullsToEndComparator(gridNumberComparator),
              valueFormatter: (value: number) => `${valOrNa(value)}`,
              renderCell: getColoredCell,
              renderHeader: (params: GridColumnHeaderParams) => (
                <SGTooltip
                  title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.optionsImpact)}
                >
                  <Typography
                    sx={{
                      ...getColHeaderStyles(params),
                    }}
                  >
                    {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.optionsImpact]}
                  </Typography>
                </SGTooltip>
              ),
            },
          ]),
    ];
  }, [
    getBlurredStyles,
    getColHeaderStyles,
    getAvg,
    gridNumberComparator,
    nullsToEndComparator,
    history,
  ]);

  const synthOIColumns = useMemo(() => {
    return [
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.high_vol_point],
        field: EquityFieldKey.high_vol_point,
        headerClassName: 'grid-header-cell',
        minWidth: 110,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        renderCell: (params: GridRenderCellParams) =>
          getColoredCell(params, true),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.high_vol_point)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.high_vol_point]}
            </Typography>
          </SGTooltip>
        ),
      },
      {
        headerName: EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.low_vol_point],
        field: EquityFieldKey.low_vol_point,
        headerClassName: 'grid-header-cell',
        minWidth: 110,
        type: 'number',
        filterOperators: customNumericOperators,
        getSortComparator: nullsToEndComparator(gridNumberComparator),
        valueFormatter: (value: number) => `${valOrNa(value)}`,
        renderCell: (params: GridRenderCellParams) =>
          getColoredCell(params, true),
        renderHeader: (params: GridColumnHeaderParams) => (
          <SGTooltip
            title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.low_vol_point)}
          >
            <Typography
              sx={{
                ...getColHeaderStyles(params),
              }}
            >
              {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.low_vol_point]}
            </Typography>
          </SGTooltip>
        ),
      },
      // Only show options impact if we're not in history mode since historical data is not available at the moment
      ...(history
        ? []
        : [
            {
              headerName:
                EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.optionsImpact],
              field: EquityFieldKey.optionsImpact,
              headerClassName: 'grid-header-cell',
              minWidth: 130,
              type: 'number',
              filterOperators: customNumericOperators,
              getSortComparator: nullsToEndComparator(gridNumberComparator),
              valueFormatter: (value: number) => `${valOrNa(value)}`,
              renderCell: getColoredCell,
              renderHeader: (params: GridColumnHeaderParams) => (
                <SGTooltip
                  title={EQUITIES_TOOLTIP_MAP.get(EquityFieldKey.optionsImpact)}
                >
                  <Typography
                    sx={{
                      ...getColHeaderStyles(params),
                    }}
                  >
                    {EQUITY_FIELD_LABEL_MAPPING[EquityFieldKey.optionsImpact]}
                  </Typography>
                </SGTooltip>
              ),
            },
          ]),
    ];
  }, [getBlurredStyles, getColHeaderStyles, gridNumberComparator, history]);

  const columns: GridColDef[] = useMemo(
    () =>
      (
        [
          ...baseColumns,
          ...(isSynthOI ? synthOIColumns : legacyColumns),
        ] as GridColDef[]
      ).filter((colDef: GridColDef) =>
        history
          ? !scannerOnlyFields.includes(colDef.field as EquityFieldKey)
          : !historyOnlyFields.includes(colDef.field as EquityFieldKey),
      ) as GridColDef[],
    [
      baseColumns,
      legacyColumns,
      isSynthOI,
      history,
      scannerOnlyFields,
      historyOnlyFields,
    ],
  );

  return {
    columns,
    columnGroups,
  };
};
